export const ACTION_TYPES = {
  PLAY: 'PLAY',
  PAUSE: 'PAUSE',
  RW: 'REWIND',
  FF: 'FF',
  STOP: 'STOP',
  CH_UP: 'CH_UP',
  CH_DOWN: 'CH_DOWN',
  PREV: 'PREV',
  NEXT: 'NEXT',
  FAVORITE: 'FAVORITE',
  EPG: 'EPG',
  SETTINGS: 'SETTINGS',
} as const;
